import React, { useEffect, useState } from "react";
import {
  useCreateCheeksStripsDataMutation,
} from "./packingApi";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import InputWithIcon from "../../../components/shared/fields/InputWithIcon";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import useTranslator from "../../../hooks/useTranslator";
import toast from "react-hot-toast";


const CheekStripModal = ({ show, setShow, record, mode, lot_number_id, total_cheeks_kg, total_strips_kg }) => {
  const isStrips = mode === "strips" || mode === "editStrips";
  const [createData, { isLoading: isCreating }] =
    useCreateCheeksStripsDataMutation();
  const { _t } = useTranslator();

// console.log('from modal');
//   console.log(record);
  const initialFormData = {
    prime: "",
    seconds: "",
    humidity: "",
    green: "",
    bone_seed: "",
    toasted: "",
    strange_material: "",
    spot: "",
    tapita: "",
    pieces: "",
    pasting: "",
    type: mode === "cheeks" ? "cheeks" : "strips",
    lot_number_id: mode === "editCheeks" ? record.data.lotNumber : lot_number_id,
  };
  const [formData, setFormData] = useState(initialFormData);

  // console.log(record);
  // console.log(mode);

  useEffect(() => {
    if((mode === "edit" || mode === "editCheeks" || mode === "editStrips") && record !== null){
      setFormData(record.data);
      
    }else{
      setFormData(initialFormData);
    }
  }, [mode, record, show]);

  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    // prevent double submission
    if (isCreating) return;

    // no required-field blocking — empty values default to 0 in payload

    if(formData?.type == "cheeks"){

      const total_cheeks_kg_sorted = (parseFloat(formData?.bone_seed) || 0) +
                                    (parseFloat(formData?.green) || 0) +
                                    (parseFloat(formData?.humidity) || 0) +
                                    (parseFloat(formData?.prime) || 0) +
                                    (parseFloat(formData?.seconds) || 0) +
                                    (parseFloat(formData?.spot) || 0) +
                                    (parseFloat(formData?.strange_material) || 0) +
                                    (parseFloat(formData?.tapita) || 0) +
                                    (parseFloat(formData?.toasted) || 0) +
                                    (parseFloat(formData?.pasting) || 0) +
                                    (parseFloat(formData?.pieces) || 0);

      
      const minimum_required = total_cheeks_kg * 0.96;

      if (total_cheeks_kg_sorted < minimum_required) {
        toast.error(
          _t(
            "sorted_weight_must_be_at_least",
            "Sorted weight must be at least :kg kg",
            { kg: minimum_required.toFixed(2) }
          )
        );
        return;
      }
    }else{
      const total_strips_kg_sorted = (parseFloat(formData?.bone_seed) || 0) +
                                    (parseFloat(formData?.green) || 0) +
                                    (parseFloat(formData?.humidity) || 0) +
                                    (parseFloat(formData?.prime) || 0) +
                                    (parseFloat(formData?.seconds) || 0) +
                                    (parseFloat(formData?.spot) || 0) +
                                    (parseFloat(formData?.strange_material) || 0) +
                                    (parseFloat(formData?.tapita) || 0) +
                                    (parseFloat(formData?.toasted) || 0) +
                                    (parseFloat(formData?.pasting) || 0) +
                                    (parseFloat(formData?.pieces) || 0);

      
      const minimum_required = total_strips_kg * 0.96;

      if (total_strips_kg_sorted < minimum_required) {
        toast.error(
          _t(
            "sorted_weight_must_be_at_least",
            "Sorted weight must be at least :kg kg",
            { kg: minimum_required.toFixed(2) }
          )
        );
        return;
      }
    }
    setFormData(formData);

    const mutation = createData;

    try {
      const payload = {
        ...formData,
        prime:            parseFloat(formData.prime)            || 0,
        seconds:          parseFloat(formData.seconds)          || 0,
        humidity:         parseFloat(formData.humidity)         || 0,
        green:            parseFloat(formData.green)            || 0,
        bone_seed:        parseFloat(formData.bone_seed)        || 0,
        toasted:          parseFloat(formData.toasted)          || 0,
        strange_material: parseFloat(formData.strange_material) || 0,
        spot:             parseFloat(formData.spot)             || 0,
        pieces:           parseFloat(formData.pieces)           || 0,
        tapita:           parseFloat(formData.tapita)           || 0,
        pasting:          parseFloat(formData.pasting)          || 0,
      };

      await mutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    setFormData(updatedFormData);
  };


  const modeLabels = {
    cheeks: _t("cheekstripmodal_titleCheeks", "Add Cheeks Log Data"),
    strips: _t("cheekstripmodal_titleStrips", "Add Strips Log Data"),
    editCheeks: _t("edit_cheek_log_data", "Edit Cheeks Log Data"),
    editStrips: _t("edit_strip_log_data", "Edit Strips Log Data"),
  };

  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <InputWithLabel
          // icon={RefreshSvg}
          label={_t("packing_batch_code", "Packing Batch Code")}
          type="number"
          name="lot_number_id"
          value={formData.lot_number_id}
          onChange={handleChange}          
          disabled={true}
          placeholder={"0"}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          icon={RefreshSvg}
          label={_t("cheekstripmodal_prime", "Prime")}
          type="number"
          name="prime"
          value={formData.prime}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          icon={RefreshSvg}
          label={_t("cheekstripmodal_seconds", "Seconds")}
          type="number"
          name="seconds"
          value={formData.seconds}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          icon={RefreshSvg}
          label={_t("cheekstripmodal_humidity", "Humidity")}
          type="number"
          name="humidity"
          value={formData.humidity}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          icon={RefreshSvg}
          label={_t("cheekstripmodal_green", "Green")}
          type="number"
          name="green"
          value={formData.green}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          icon={RefreshSvg}
          label={_t("cheekstripmodal_bone_seed", "Bone/Seed")}
          type="number"
          name="bone_seed"
          value={formData.bone_seed}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          label={_t("cheekstripmodal_toasted", "Toasted")}
          type="number"
          name="toasted"
          value={formData.toasted}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          icon={RefreshSvg}
          label={_t("cheekstripmodal_strange_material", "Strange Material")}
          type="number"
          name="strange_material"
          value={formData.strange_material}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("cheekstripmodal_spot", "Spot")}
          type="number"
          name="spot"
          value={formData.spot}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
      <Col lg={6}>
        <InputWithIcon
          icon={RefreshSvg}
          label={_t("cheekstripmodal_pieces", "Pieces")}
          type="number"
          name="pieces"
          value={formData.pieces}
          onChange={handleChange}
          placeholder={"0"}
          required={true}
        />
      </Col>
     
      {!isStrips && (
        <Col lg={6}>
          <InputWithIcon
            icon={RefreshSvg}
            label={_t("tapita", "Tapita")}
            type="number"
            name="tapita"
            value={formData.tapita}
            onChange={handleChange}
            placeholder={"0"}
            required={true}
          />
        </Col>
      )}
      <Col lg={6}>
        <InputWithLabel
          label={_t("pasting", "Pasting")}
          type="number"
          name="pasting"
          value={formData.pasting}
          onChange={handleChange}
          placeholder={"0"}
        />
      </Col>
    </>
  );

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={modeLabels[mode]}
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("cheekstripmodal_saveChanges", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default CheekStripModal;
